import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import knowledgeList from "./modules/knowledge/knowledgeList";
import knowledgeEdit from "./modules/knowledge/knowledgeEdit";
import clazzStandard from './modules/clazzStandard/ClazzStandard'
import course from './modules/course/Course'
import major from "./modules/major/Major";
import dept from "./modules/dept/Dept";
import schoolTerm from './modules/schoolTerm/SchoolTerm'
import team from './modules/team/Team'
import clazzCourse from './modules/clazzCourse/ClazzCourse'
import role from './modules/role/Role'
import getters from "./getters";
import textbook from './modules/textbook'
import security from './modules/security'
import textbookMaker from './modules/textbook/maker'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    account,
    knowledgeList,
    knowledgeEdit,
    clazzStandard,
    course,
    major,
    dept,
    schoolTerm,
    team,
    clazzCourse,
    role,
    textbook,
    security,
    textbookMaker
  },
  getters
})
